/* AirGreen · murale ou centrale · runtime (render AST -> HTML, morph, delegated events, video) */
(function (G) {
  'use strict';
  var NBSP = String.fromCharCode(160);
  var VOID = { area: 1, base: 1, br: 1, col: 1, embed: 1, hr: 1, img: 1, input: 1, link: 1, meta: 1, source: 1, track: 1, wbr: 1 };
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').split(NBSP).join('&nbsp;'); }
  function escA(s) { return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').split(NBSP).join('&nbsp;'); }
  function get(sc, p) { var k = p.split('.'), v = sc[k[0]]; for (var i = 1; i < k.length && v != null; i++) v = v[k[i]]; return v; }
  function str(v) { return v == null ? '' : String(v); }
  function R(nodes, sc, H, out) {
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (typeof n === 'string') { out.push(esc(n)); continue; }
      if (!Array.isArray(n)) { out.push(esc(str(get(sc, n.$)))); continue; }
      var t = n[0];
      if (t === '#f') {
        var L = get(sc, n[1]) || [];
        for (var j = 0; j < L.length; j++) { var s2 = Object.create(sc); s2[n[2]] = L[j]; R(n[3], s2, H, out); }
        continue;
      }
      if (t === '#i') { if (get(sc, n[1])) R(n[2], sc, H, out); continue; }
      out.push('<' + t);
      var A = n[1];
      for (var a = 0; a < A.length; a++) {
        var k = A[a][0], v = A[a][1];
        if (k === '@c' || k === '@i') {
          var f = get(sc, v);
          if (typeof f === 'function') { H.push(f); out.push(' data-ag' + (k === '@c' ? 'c' : 'i') + '="' + (H.length - 1) + '"'); }
          continue;
        }
        if (typeof v !== 'string') {
          var s = '';
          for (var b = 0; b < v.length; b++) s += typeof v[b] === 'string' ? v[b] : str(get(sc, v[b].$));
          v = s;
        }
        out.push(' ' + k + '="' + escA(v) + '"');
      }
      out.push('>');
      if (VOID[t]) continue;
      R(n[2], sc, H, out);
      out.push('</' + t + '>');
    }
  }
  function render(ast, V, H) { var out = []; R(ast, V, H, out); return out.join(''); }

  if (typeof module !== 'undefined' && module.exports) { module.exports = { render: render }; return; }

  /* ---------------- morph */
  function same(o, n) { return o.nodeType === n.nodeType && (o.nodeType !== 1 || o.nodeName === n.nodeName); }
  function syncAttrs(o, n) {
    var i, a;
    for (i = o.attributes.length - 1; i >= 0; i--) { a = o.attributes[i]; if (!n.hasAttribute(a.name)) o.removeAttribute(a.name); }
    for (i = 0; i < n.attributes.length; i++) { a = n.attributes[i]; if (o.getAttribute(a.name) !== a.value) o.setAttribute(a.name, a.value); }
    if (o.nodeName === 'INPUT') { var v = n.getAttribute('value') || ''; if (o.value !== v) o.value = v; }
  }
  function morphKids(a, b) {
    var oc = a.firstChild, nc = b.firstChild;
    while (nc) {
      var nn = nc.nextSibling;
      if (!oc) { a.appendChild(nc); }
      else if (same(oc, nc)) {
        if (oc.nodeType === 1) { syncAttrs(oc, nc); morphKids(oc, nc); }
        else if (oc.nodeValue !== nc.nodeValue) { oc.nodeValue = nc.nodeValue; }
        oc = oc.nextSibling;
      } else { var no = oc.nextSibling; a.replaceChild(nc, oc); oc = no; }
      nc = nn;
    }
    while (oc) { var t = oc.nextSibling; a.removeChild(oc); oc = t; }
  }
  function morph(root, html) { var tpl = document.createElement('template'); tpl.innerHTML = html; morphKids(root, tpl.content); }

  /* ---------------- app */
  function start() {
    var ASTS = G.AGMC_AST, Logic = G.AGMC_LOGIC, host = document.getElementById('agmc');
    if (!host) return;
    host.classList.add('agmc-js');
    initVideo(host);
    if (!ASTS || !Logic) return;
    var C = Logic(), comp = new C(), roots = {}, H = {}, queued = false;
    function flush() {
      queued = false;
      var V = comp.renderVals();
      for (var name in roots) { var h = []; var html = render(ASTS[name], V, h); H[name] = h; morph(roots[name], html); }
    }
    comp.setState = function (p) {
      if (typeof p === 'function') p = p(comp.state);
      for (var k in p) comp.state[k] = p[k];
      if (!queued) { queued = true; Promise.resolve().then(flush); }
    };
    var els = host.querySelectorAll('[data-agw]');
    Array.prototype.forEach.call(els, function (el) {
      var name = el.getAttribute('data-agw');
      if (!ASTS[name]) return;
      roots[name] = el;
      el.addEventListener('click', function (e) {
        var t = e.target.closest ? e.target.closest('[data-agc]') : null;
        if (!t || !el.contains(t)) return;
        var f = (H[name] || [])[+t.getAttribute('data-agc')];
        if (f) f(e);
      });
      el.addEventListener('input', function (e) {
        var t = e.target.closest ? e.target.closest('[data-agi]') : null;
        if (!t || !el.contains(t)) return;
        var f = (H[name] || [])[+t.getAttribute('data-agi')];
        if (f) f(e);
      });
    });
    try { flush(); } catch (err) { if (G.console) console.error('[agmc]', err); }
  }

  function initVideo(host) {
    host.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('[data-agvideo]') : null;
      if (!a || e.ctrlKey || e.metaKey || e.shiftKey) return;
      e.preventDefault();
      var id = a.getAttribute('data-agvideo'), box = document.createElement('div');
      box.className = 'agmc-vid';
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
      f.title = a.getAttribute('data-agvtitle') || 'YouTube';
      f.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
      f.setAttribute('allowfullscreen', '');
      box.appendChild(f);
      a.parentNode.replaceChild(box, a);
      f.focus();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})(typeof window !== 'undefined' ? window : this);
